import { SimilarPsyLinks } from "modules/PsyProfile/components/FAQContainer/SimilarPsyLinks"
import style from "modules/PsyProfile/components/FAQContainer/style.module.scss"
import { Psychologist } from "utils/interfaces"
import { FAQ, ProfileItem } from "components/FAQ"

export function FAQContainer({ psy }: { psy: Psychologist }) {
    return (
        <section className={style.container}>
            <FAQ
                renderProp={SimilarPsyLinks(psy).map((faqItem, index) => (
                    <ProfileItem faqItem={faqItem} key={index} />
                ))}
                data-testid="psy-profile-faq-title"
            />
        </section>
    )
}
